<template>
  <v-theme-provider :dark="dark">
    <v-container class="pa-0">
      <v-row
        no-gutters
      >
        <div class="col-12">
          <div class="card mt-1">
            <div class="card-body">
              <div id="cba_sf">
                <table>
                  <tbody style="font-size:12px;line-height: 1.3;font-family:Arial,sans-serif;text-align:center;">
                    <tr>
                      <td
                        :style="`text-align:center;font-size:26px;padding:7px 0;background-color: ${$vuetify.theme.themes.light.signatureBg}`"
                      >
                        <b style="color: #000000; font-weight: 700;">vibe&nbsp;</b><b
                          style="color:#000000; font-weight: 500;"
                        >moves you</b>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-top:10px;">
                        <b style="font-size: 14px; color: #000000">
                          {{ firstName }} {{ lastName }}, {{ funct }} </b>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="margin:0;padding:0;line-height:15px;color:#000000"
                      >
                        <span
                          style="color: inherit"
                        >{{ phone }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="margin:0;padding:0;font-weight:100;color:#000000;"
                      >
                        {{ email }}
                        &nbsp;|&nbsp;
                        {{ website }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="margin:0;padding:0;font-weight:100;color:#000000;"
                      >
                        <b>vibe&nbsp;</b>
                        <span>homebase</span>
                        &nbsp;|&nbsp;
                        Brunner Straße 63, A-1230 Wien
                      </td>
                    </tr>
                    <tr v-if="linkedIn">
                      <td :style="`text-align:center;margin:0;padding:0;font-family:Arial, sans-serif; font-size:12px;;color: ${$vuetify.theme.themes.light.primary};mso-line-height-rule:exactly; line-height:15px;`">
                        <span style="color: #000000">
                          <a
                            :href="`https://${linkedIn}`"
                            style="text-decoration-color: #000000!important;text-decoration: none!important; color: #000000; font-size: 12px; font-family: Arial, sans-serif; font-weight: 100;"
                            target="_blank"
                          >
                            {{ linkedIn }}
                          </a>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="font-size:10px;padding:7px 0;color:#000000;"
                        >
                        <span>{{ companyName }}, {{ companyAddress }} | UID: {{ companyUID }} | FN: {{ companyFN }} | FB-Gericht: {{ companyFB }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align:center;margin:0;padding:0;font-family:Arial, sans-serif; font-size:10px;color:#000000;mso-line-height-rule:exactly; line-height:12px;">
                        <span style="font-size: 10px; font-family: Arial, sans-serif; color: #000000;">Der Schutz Ihrer Daten ist uns wichtig. Informationen zur Verarbeitung Ihrer Daten <br> (Art. 13 DSGVO) finden Sie unter <a
                          :href="`https://vibemovesyou.com?utm_source=${email}&utm_medium=email&utm_campaign=email_signature_legal`"
                          style="text-decoration: none; color: #000000; font-size: 10px; font-family: Arial, sans-serif; font-weight: 100;"
                        >vibemovesyou.com</a>.</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </v-row>
    </v-container>
  </v-theme-provider>
</template>

<script>
  // Mixins
  import Heading from '@/mixins/heading'

  export default {
    name: 'BaseSignatureCard',

    mixins: [Heading],

    props: {
      dark: Boolean,
      callout: String,
      color: {
        type: String,
        default: 'primary',
      },
      firstName: String,
      lastName: String,
      phone: String,
      email: String,
      website: String,
      linkedIn: String,
      companyName: String,
      companyAddress: String,
      companyUID: String,
      companyFN: String,
      companyFB: String,
      funct: String,
    },
  }
</script>
